import { Col, Container, Nav, Row } from "react-bootstrap";
import "./css/style.css";
import { useEffect, useState } from "react";

export default function Header() {
    const [isDarkBackground, setIsDarkBackground] = useState(true);
    const [isHeaderVisible, setIsHeaderVisible] = useState(true);
    const [lastScrollY, setLastScrollY] = useState(0);
    const [isMenuOpen, setIsMenuOpen] = useState(false);

    useEffect(() => {
        const handleScroll = () => {
            const scrollPosition = window.scrollY;
            const sectionHeight = window.innerHeight;
            if (scrollPosition < sectionHeight) {
                setIsDarkBackground(true);
            } else {
                setIsDarkBackground(false);
            }
            if (scrollPosition > lastScrollY) {
                setIsHeaderVisible(false);
            } else {
                setIsHeaderVisible(true);
            }
            setLastScrollY(scrollPosition);
        };
        window.addEventListener("scroll", handleScroll);
        return () => {
            window.removeEventListener("scroll", handleScroll);
        };
    }, [lastScrollY]);

    const toggleMenu = () => {
        setIsMenuOpen(!isMenuOpen);
        if (!isMenuOpen) {
            document.body.style.overflow = "hidden";
        } else {
            document.body.style.overflow = "auto";
        }
    };

    const closeMenu = () => {
        setIsMenuOpen(false);
        document.body.style.overflow = "auto";
    };

    return (
        <header className={`header ${isDarkBackground ? "light" : "dark"} ${isHeaderVisible ? "visible" : "hidden"}`}>
            <Container>
                <Row className="header_list">
                    <Col className="header_list_superfluous">
                        <Nav className="header_list_nav flex">
                            <Nav.Link className="header_link gradientT t16 header_list_item" href="#services" onClick={closeMenu}>
                                услуги
                            </Nav.Link>
                            <Nav.Link className="header_link gradientT t16 header_list_item" href="#advantages" onClick={closeMenu}>
                                преимущества
                            </Nav.Link>
                        </Nav>
                    </Col>
                    <Col>
                        <a href="" className="header_list_nav flex">
                            {isDarkBackground ? (
                                <img className="header_logo" src="/logo.png" alt="" />
                            ) : (
                                <img className="header_logo" src="/logolight.png" alt="" />
                            )}
                        </a>
                    </Col>
                    <Col>
                        <Nav className="header_list_nav header_list_nav_contacts flex">
                            <Nav.Link className="header_link t16 gradientT header_list_item" href="#reviews" onClick={closeMenu}>
                                отзывы
                            </Nav.Link>
                            <a href="tel:+79278223311" className="header_link t24 tel gradientT">
                                +7-927-822-33-11
                            </a>
                            <Nav.Link className="header_link t16 header_link_wp flex adaptiv_phone" href="tel:+79278223311">
                                <img className="" src="/img/icon/phone.svg" alt="" />
                            </Nav.Link>
                            <Nav.Link
                                className="header_link t16 header_link_wp flex"
                                target="_blank"
                                href="https://api.whatsapp.com/send?phone=79278223311"
                                onClick={closeMenu}>
                                <img className="" src="/img/icon/wp.svg" alt="" />
                            </Nav.Link>
                        </Nav>
                    </Col>
                    <div className="header_burger_menu" onClick={toggleMenu}>
                        <div className={`burger ${isMenuOpen ? "active" : ""}`}>
                            <span></span>
                            <span></span>
                            <span></span>
                        </div>
                    </div>
                </Row>
            </Container>
            {isMenuOpen && (
                <div className={`burger_menu ${isMenuOpen ? "active" : ""}`}>
                    <div className="burger_menu_content">
                        <Nav className="burger_nav">
                            <a href="" className="header_list_nav flex">
                                <img className="header_logo" src="/logo.png" alt="" />
                            </a>
                            <a href="#advantages" className="burger_link" onClick={closeMenu}>
                                Преимущества
                            </a>
                            <a href="#services" className="burger_link" onClick={closeMenu}>
                                Услуги
                            </a>
                            <a href="#reviews" className="burger_link" onClick={closeMenu}>
                                Отзывы
                            </a>
                            <a href="#footer" className="burger_link" onClick={closeMenu}>
                                Контакты
                            </a>
                        </Nav>
                        <div className="burger_menu_number_wp">
                            <a href="tel:+79278223311" className="burger_menu_phone">
                                +7-927-822-33-11
                            </a>
                            <a
                                target="_blank"
                                href="https://api.whatsapp.com/send?phone=79278223311"
                                className="header_link t16 header_link_wp flex nav-link"
                                onClick={closeMenu}>
                                <img className="" alt="" src="/img/icon/wp.svg"></img>
                            </a>
                        </div>
                    </div>
                </div>
            )}
        </header>
    );
}
